import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import './styles.css';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import CheckCircleIcon from '@material-ui/icons/CheckCircleOutlined';
import ErrorOutlineOutlinedIcon from '@material-ui/icons/ErrorOutlineOutlined';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import useSnackBar from '../../hooks/use-snackbar';

const styles = {
  success: {
    backgroundColor: '#4CAF50',
    borderRadius: '5px',
    width: '100%'
  },
  error: {
    fontSize: '12px',
    fontFamily: 'jioType-Medium',
    backgroundColor: '#EB0000',
    borderRadius: '5px'
  },
  info: {
    backgroundColor: '#4CAF50',
    borderRadius: '5px'
  },
  warning: {
    backgroundColor: '#EB0000',
    borderRadius: '5px'
  },
  icon: {
    height: '25px',
    width: '25px',
    color: '#FFFFFF'
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: '12px',
    marginLeft: '-5px'
  },
  message: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '12px',
    width: '100%',
    justifyContent: 'space-between'
  },
  root: {
    maxWidth: 600
  },
  snackbar: {
    margin: '12px 16px 0px 16px',
    height: '53px'
  }
  // icon: {
  //   marginLeft: '10px'
  // }
};

const vertical = 'top';
const horizontal = 'center';

const variantIcon = {
  success: CheckCircleIcon,
  error: ErrorOutlineOutlinedIcon,
  warning: ReportProblemOutlinedIcon,
  info: InfoOutlinedIcon
};

export default () => {
  const {
    open, message, variant, hide
  } = useSnackBar();
  const handleClose = () => {
    hide();
  };

  const Icon = variantIcon[variant] || null;
  return (
    <Snackbar
      anchorOrigin={{ vertical, horizontal }}
      key={`${vertical},${horizontal}`}
      open={open}
      style={styles.snackbar}
      onClose={handleClose}
      autoHideDuration={5000}
    >
      <SnackbarContent
        style={styles[variant]}
        aria-describedby="client-snackbar"
        message={(
          <span id="client-snackbar" style={styles.message}>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              {Icon && <Icon style={{ marginRight: '10px', alignSelf: 'center' }} />}
              <div>
                {message}
              </div>
            </div>
            <IconButton style={styles.icon} size="small" aria-label="close" color="inherit" onClick={handleClose}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </span>
        )}
      />
    </Snackbar>
  );
};
